import axiosAuth from "../../../utils/axiosWithAuth";
import { IconButton, Typography, TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useState, useContext } from "react";
import Autocomplete from "@material-ui/core";
import UtilityCompanySelector from "./UtilityCompanySelector";

export default function AuthorizationCreateAccountForm({ authorization, setAuthorization, fetchAuthorization, utilityCompanies}) {
  const [accountNumber, setAccountNumber] = useState("")
  const [utilityCompanyId, setUtilityCompanyId] = useState(null)
  const handleAdd = () => {
    const newAccount = {
      account_number: accountNumber,
      utility_company_id: utilityCompanyId,
      online_access_url: authorization.online_access_url,
      online_access_username: authorization.online_access_username,
      online_access_password: authorization.online_access_password

    };
    axiosAuth()
      .post(`/authorizations/${authorization.id}/accounts`, {
        authorization_id: authorization.id,
        newAccount,
      })
      .then((createResponse) => {
        setAccountNumber("")
        fetchAuthorization()
      })
      .catch((err) => console.log(err.response));
  };

  const handleChange = (e) => setAccountNumber(e.target.value);
  const handleUtilityCompanyChange = e => setUtilityCompanyId(e.target.value)

  return (
    <div 
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center", // Vertically align items
      padding: "16px", // Optional: Add padding for better spacing
      gap: "10px"
    }}>
      <Typography variant="h4">Create account:</Typography>
      <TextField
        style={{ width: 500 }}
        value={accountNumber}
        onChange={handleChange}
        placeholder="Enter account number"
      />
      <UtilityCompanySelector 
        utilityCompanyId={utilityCompanyId}
        utilityCompanies={utilityCompanies}
        handleUtilityCompanyChange={handleUtilityCompanyChange }
      />
      <IconButton disabled={!accountNumber || !utilityCompanyId} color="primary">
        <Add onClick={handleAdd} />
      </IconButton>
    </div>
    
  );
}